import type { ButtonHTMLAttributes } from "react";
import styles from "./Button.module.css";

export type ButtonVariant = "primary" | "secondary" | "ghost" | "danger";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  block?: boolean;
  selected?: boolean;
}

export function Button({ variant = "secondary", block = false, selected = false, className = "", type = "button", ...rest }: ButtonProps) {
  const classes = [styles.button, styles[variant], block ? styles.block : "", selected ? styles.selected : "", className];
  return <button type={type} className={classes.join(" ").trim()} aria-pressed={selected || undefined} {...rest} />;
}
